var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('md-card',[_c('md-card-header',[_c('div',{staticClass:"card-icon p-1 bg-danger"},[_c('md-icon',{},[_vm._v("sports_volleyball")])],1),_c('h4',{staticClass:"title mt-2"},[_vm._v("Ejercicios")])]),_c('md-card-content',[_c('ExerciseList')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }